export default __webpack_public_path__ + "static/media/inactive-radio-button.8944f2e1.svg";